module.exports = __webpack_public_path__ + "img/logo.dbbb1472.svg";